import React from "react";
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer
      className="footer-section fix bg-cover"
      style={{ backgroundImage: "url('/img/footer/footer-bg.jpg')" }}
    >
      <div className="container">
        <div className="footer-widget-wrapper-new">
          <div className="row">
            {/* Logo & Newsletter */}


            {/* Our Services  */}
            <div
              className="col-xl-3 col-lg-3 col-md-4 col-sm-6 ps-lg-5 wow fadeInUp"
              data-wow-delay=".4s"
            >
              <div className="single-widget-items">
                <div className="widget-head">
                  <h4>Our Services </h4>
                </div>
                <Link className="mx-md-2 darkcoloo d-block" to="/bus-booking-for-marriage"><i className="fa fa-bus darkcolo"></i> Bus Booking for Marriage</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/bus-hire-for-wedding-in-pune"><i className="fa fa-bus darkcolo"></i> Bus Hire for Wedding in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/bus-hire-near-me-pune"><i className="fa fa-bus darkcolo"></i> Bus Hire Near Me Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/bus-hire-for-outstation"><i className="fa fa-bus darkcolo"></i> Bus Hire for Outstation</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/bus-service-for-corporate-pune"><i className="fa fa-bus darkcolo"></i> Bus Service for Corporate Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/bus-service-for-corporate-events"><i className="fa fa-bus darkcolo"></i> Bus Service for Corporate Events</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/bus-service-for-picnic-in-pune"><i className="fa fa-bus darkcolo"></i> Bus Service for Picnic in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/bus-rentals-for-school-trips-in-pune"><i className="fa fa-bus darkcolo"></i> Bus Rentals for School Trips in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/bus-hire-for-school-trips-in-pune"><i className="fa fa-bus darkcolo"></i> Bus Hire for School Trips in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/bus-rental-for-tour-packages"><i className="fa fa-bus darkcolo"></i> Bus Rental for Tour Packages</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/bus-on-rent-for-event-in-pune"><i className="fa fa-bus darkcolo"></i> Bus on Rent for Event in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/non-ac-bus-rental-service-in-pune"><i className="fa fa-bus darkcolo"></i> Non AC Bus Rental Service in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/ac-bus-on-rent-in-pune"><i className="fa fa-bus darkcolo"></i> AC Bus On Rent in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-local-bus-on-rent"><i className="fa fa-bus darkcolo"></i> Pune Local Bus on Rent</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/bus-on-rent-in-pune"><i className="fa fa-bus darkcolo"></i> Bus On Rent in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/bus-on-rent-in-pimpri-chinchwad"><i className="fa fa-bus darkcolo"></i> Bus On Rent in Pimpri Chinchwad</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/25-seater-tempo-traveller-on-rent-in-pune"><i className="fa fa-bus darkcolo"></i> 25 Seater Tempo Traveller on Rent in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/32-seater-bus-rent-in-pune"><i className="fa fa-bus darkcolo"></i> 32 Seater Bus Rent in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/35-seater-bus-on-rent-in-pune"><i className="fa fa-bus darkcolo"></i> 35 Seater Bus on Rent in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/40-seater-bus-on-rent-in-pune"><i className="fa fa-bus darkcolo"></i> 40 Seater Bus on Rent in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/45-seater-bus-on-rent-in-pune"><i className="fa fa-bus darkcolo"></i> 45 Seater Bus on Rent in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/50-seater-bus-on-rent-in-pune"><i className="fa fa-bus darkcolo"></i> 50 Seater Bus on Rent in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/32-seater-tempo-traveller-service"><i className="fa fa-bus darkcolo"></i> 32 Seater Tempo Traveller Service</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-mumbai-darshan-bus-on-rent"><i className="fa fa-bus darkcolo"></i> Pune to Mumbai Darshan Bus on Rent</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-shirdi-bus-hire"><i className="fa fa-bus darkcolo"></i> Pune to Shirdi Bus Hire</Link>

              </div>
            </div>





            {/* Our Services  */}
            <div
              className="col-xl-3 col-lg-3 col-md-4 col-sm-6 ps-lg-5 wow fadeInUp"
              data-wow-delay=".4s"
            >
              <div className="single-widget-items">
                <div className="widget-head">
                  <h4>Our Services </h4>
                </div>

                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-ganpatipule-beach-bus-rental-service"><i className="fa fa-bus darkcolo"></i> Pune to Ganpatipule Beach Bus Rental Service</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-kolhapur-bus-on-rent"><i className="fa fa-bus darkcolo"></i> Pune to Kolhapur Bus on Rent</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-aurangabad-bus-hire-on-rent"><i className="fa fa-bus darkcolo"></i> Pune to Aurangabad Bus Hire on Rent</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-pandharpur-bus-hire"><i className="fa fa-bus darkcolo"></i> Pune to Pandharpur Bus Hire</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-sade-teen-shakti-peeth-bus-on-rent"><i className="fa fa-bus darkcolo"></i> Pune Sade Teen Shakti Peeth Bus on Rent</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-lonavala-bus-hire"><i className="fa fa-bus darkcolo"></i> Pune to Lonavala Bus Hire</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-5-jyotirlinga-darshan-bus-hire"><i className="fa fa-bus darkcolo"></i> Pune to 5 Jyotirlinga Darshan Bus Hire</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-bhimashankar-jyotirlinga-bus-hire-in-pune"><i className="fa fa-bus darkcolo"></i> Pune to Bhimashankar Jyotirlinga Bus Hire in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/luxury-force-urbania-on-rent-in-pune"><i className="fa fa-bus darkcolo"></i> Luxury Force Urbania on Rent in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/force-urbania-on-rent-in-pune"><i className="fa fa-bus darkcolo"></i> Force Urbania on Rent in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/urbania-tourist-bus-on-rent-in-pune"><i className="fa fa-bus darkcolo"></i> Urbania Tourist Bus on Rent in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/13-seater-force-urbania-on-rent-in-pune"><i className="fa fa-bus darkcolo"></i> 13 Seater Force Urbania on Rent in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/17-seater-force-urbania-on-rent-in-pune"><i className="fa fa-bus darkcolo"></i> 17 Seater Force Urbania on Rent in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/urbania-on-rent-in-pimpri-chinchwad"><i className="fa fa-bus darkcolo"></i> Urbania on Rent in Pimpri Chinchwad</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/urbania-hire-for-corporate-event-in-pune"><i className="fa fa-bus darkcolo"></i> Urbania Hire for Corporate Event in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-mumbai-urbania-on-rent"><i className="fa fa-bus darkcolo"></i> Pune to Mumbai Urbania on Rent</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-shirdi-force-urbania-on-rent"><i className="fa fa-bus darkcolo"></i> Pune to Shirdi Force Urbania on Rent</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-mahabaleshwar-urbania-on-rent"><i className="fa fa-bus darkcolo"></i> Pune to Mahabaleshwar Urbania on Rent</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-goa-urbania-on-rent"><i className="fa fa-bus darkcolo"></i> Pune to Goa Urbania on Rent</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-ashtavinayak-urbania-tour-package"><i className="fa fa-bus darkcolo"></i> Pune to Ashtavinayak Urbania Tour Package</Link>

                <Link className="mx-md-2 darkcoloo d-block" to="/urbania-hire-for-outstation-in-pune"><i className="fa fa-bus darkcolo"></i> Urbania Hire for Outstation in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/urbania-luxury-bus-rentals-in-pune"><i className="fa fa-bus darkcolo"></i> Urbania Luxury Bus Rentals in Pune</Link>

              </div>
            </div>









            <div
              className="col-xl-3 col-lg-3 col-md-4 col-sm-6 ps-lg-5 wow fadeInUp"
              data-wow-delay=".4s"
            >
              <div className="single-widget-items">
                <div className="widget-head">
                  <h4>Our Services </h4>
                </div>
                <Link className="mx-md-2 darkcoloo d-block" to="/urbania-on-rent-in-pune"><i className="fa fa-bus darkcolo"></i> Urbania on Rent in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-outstation-urbania-bus-hire-in-pune"><i className="fa fa-bus darkcolo"></i> Pune to Outstation Urbania Bus Hire in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/luxury-tempo-traveller-on-rent-in-pune"><i className="fa fa-bus darkcolo"></i> Luxury Tempo Traveller on Rent in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/tempo-traveller-hire-for-outstation-in-pune"><i className="fa fa-bus darkcolo"></i> Tempo Traveller Hire for Outstation in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/swift-dzire-on-rent-in-pune"><i className="fa fa-bus darkcolo"></i> Swift Dzire On Rent in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-bhimashankar-cab"><i className="fa fa-bus darkcolo"></i> Pune to Bhimashankar Cab</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-sambhajinagar-taxi"><i className="fa fa-bus darkcolo"></i> Pune to Sambhajinagar Taxi</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-konkan-darshan-cabs"><i className="fa fa-bus darkcolo"></i> Pune to Konkan Darshan Cabs</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/tempo-traveller-on-rent-in-pune"><i className="fa fa-bus darkcolo"></i> Tempo Traveller On Rent in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-mumbai-international-airport-cab"><i className="fa fa-bus darkcolo"></i> Pune to Mumbai International Airport Cab</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-shirdi-cab"><i className="fa fa-bus darkcolo"></i> Pune to Shirdi Cab</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-cab-service"><i className="fa fa-bus darkcolo"></i> Pune Cab Service</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-lavasa-city-cabs"><i className="fa fa-bus darkcolo"></i> Pune to Lavasa City Cabs</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/mini-bus-on-rent-in-pune"><i className="fa fa-bus darkcolo"></i> Mini Bus On Rent in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-mahabaleshwar-cabs"><i className="fa fa-bus darkcolo"></i> Pune to Mahabaleshwar Cabs</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-panchgani-cab-fare"><i className="fa fa-bus darkcolo"></i> Pune to Panchgani Cab Fare</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/ertiga-on-rent-in-pune"><i className="fa fa-bus darkcolo"></i> Ertiga On Rent in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-lonavala-cabs"><i className="fa fa-bus darkcolo"></i> Pune to Lonavala Cabs</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-pandharpur-taxi"><i className="fa fa-bus darkcolo"></i> Pune to Pandharpur Taxi</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/best-cab-service-in-pune"><i className="fa fa-bus darkcolo"></i> Best Cab Service in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-online-cab-booking"><i className="fa fa-bus darkcolo"></i> Pune Online Cab Booking</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/corporate-cab-service-in-pune"><i className="fa fa-bus darkcolo"></i> Corporate Cab Service in Pune</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-goa-cabs"><i className="fa fa-bus darkcolo"></i> Pune to Goa Cabs</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-ajanta-ellora-cabs"><i className="fa fa-bus darkcolo"></i> Pune to Ajanta Ellora Cabs</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-airport-to-mumbai-taxi"><i className="fa fa-bus darkcolo"></i> Pune Airport to Mumbai Taxi</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/ashtavinayak-darshan-cab"><i className="fa fa-bus darkcolo"></i> Ashtavinayak Darshan Cab</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-to-mumbai-cabs"><i className="fa fa-bus darkcolo"></i> Pune to Mumbai Cabs</Link>
                <Link className="mx-md-2 darkcoloo d-block" to="/pune-outstation-cabs"><i className="fa fa-bus darkcolo"></i> Pune Outstation Cabs</Link>

              </div>
            </div>






















            {/* Contact Info */}
            <div
              className="col-xl-3 col-lg-4 col-md-6 col-sm-6 ps-xl-5 wow fadeInUp"
              data-wow-delay=".6s"
            >
              <div className="single-widget-items">
                <div className="widget-head">
                  <h4>Contact Us</h4>
                </div>
                <div className="contact-info">


                  <div className="contact-items">
                    <div className="icon">
                      <i className="fa-solid fa-phone"></i>
                    </div>
                    <div className="content">
                      <h6>
                        <a href="tel:+919765685295">+91 9765685295</a> <br />
                        <a href="tel:+919881872524">+91 9881872524</a>
                      </h6>
                    </div>
                  </div>


                  <div className="contact-items">
                    <div className="icon">
                      <i className="fa-regular fa-envelope"></i>
                    </div>
                    <div className="content">
                      <h6>
                        <a href="mailto:booking@vaishnavitravel.com">booking@vaishnavitravel.com</a>
                      </h6>
                    </div>
                  </div>

                  <div className="contact-items">
                    <div className="icon">
                      <i className="fas fa-location-dot"></i>
                    </div>
                    <div className="content">
                      <h6>
                        Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                      </h6>
                    </div>
                  </div>

                  <iframe src="https://www.google.com/maps/embed?pb=!3m2!1sen!2sin!4v1790223349416!5m2!1sen!2sin!6m8!1m7!1siWm6x-i-1qA6jZCErwDOAA!2m2!1d18.58516603624576!2d73.7817432900832!3f244.79576930760527!4f11.071244338675385!5f0.4004233368561733" width="auto" height="250" allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>



                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-wrapper">
            <p className="copyright-text text-white">
              All Rights Reserved &copy;  <span className="All Rights Reserved">Vaishnavi Travels</span> <span id="date">{new Date().getFullYear()}</span>{' '}
              <span href="#"> Developed By </span> <a href="https://www.dexterintelligence.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                <span className="darkcolor">&nbsp;Dexter Intelligence</span>
              </a> | Hosted By <a href="https://www.urvahosting.com/" className='d-inline ' target="_blank" rel="noopener noreferrer">
                <span className="darkcolor">&nbsp;Urva Hosting</span>
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
